export default __webpack_public_path__ + "static/media/geo_fake.dfadcd7c.zip";